///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../collections/services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class MembershipsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected memberships: MembershipsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.memberships;
        }

        get leafCollection() {
            return this.memberships;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[0]];
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            if (options.criteria.showInactiveFilter) {
                this.filters = [new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_MEMBERSHIPS'}, this, true)];
            }

            this.memberships = new MembershipsCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden,
                showInactiveLabel: options.criteria.showInactiveFilter,
                inactiveLabel: options.inactiveLabel
        });
            if (options.criteria.showInactiveFilter) {
                this.memberships.addFilters(...this.filters as IInteractiveFilter[]);
            }
            this.showAllSelected = angular.isDefined(options.criteria.showAllSelected) ? options.criteria.showAllSelected : true;
            this.title = 'LABEL_MEMBERSHIPS';
            this.allSelectedLabel = 'LABEL_ALL_MEMBERSHIPS';
            this.totalSelectedMessage = 'LABEL_TOTAL_MEMBERSHIPS_SELECTED';

            if (options.required) {
                this.validation.push(new RequiredValidation(this.collection, 'LABEL_MEMBERSHIP_REQUIRED'));
            }
        }
    }
}
